export default __webpack_public_path__ + "static/media/bird-bluetit-animated-moving.374f7c92.svg";